import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Add as AddIcon } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { Paper } from "../../../../../common/components/libs";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { MenuFormType } from "../../../store/menu/forms";
import {Trans, useTranslation} from "react-i18next";


const Wrapper = styled(Paper)`
  padding: ${
    props => {
        return props.theme.spacing(6)
    }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;


const NoMenuItems = () => {
    const {menuStore} = useStores();
    const {forms} = menuStore;
    const hasIIkoIntegration = menuStore.hasIIkoIntegration();
    const {t} = useTranslation(["general", "menu"]);


    return <div style={{maxWidth: 500}}>
        <Wrapper>
            <>
                <Typography component="h1" variant="h4" align="center" gutterBottom>
                    {t("menu:menuEditor.timeAddFirstPosition")} <span role='img' aria-label='newItem'>😃</span>
                </Typography>
                <Typography component="h4" variant="body2" align="center" gutterBottom>
                    {t("menu:menuEditor.descriptionPosition")}
                </Typography>
                <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                    <Button variant="contained"
                            color="primary"
                            onClick={() => forms.showPopupForm(MenuFormType.createMenuItem)}
                    >
                        <AddIcon/>
                        {t("menu:menuEditor.toAddPosition")}
                    </Button>
                </div>
            </>
        </Wrapper>
    </div>
};


export default observer(NoMenuItems)
